export interface BlogCategory {
  key: string;
  label: string;
  description: string;
  // Accent color used by the list filter chips and the auto-generated cover.
  // SOURCE OF TRUTH for the cover accent lives in scripts/generate-blog.js
  // (BLOG_CATEGORIES) - keep the two in sync.
  color: string;
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  {
    key: 'color-theory',
    label: 'Color Theory',
    description: 'How color works: hue, contrast, perception and accessibility for code.',
    color: '#549EFF',
  },
  {
    key: 'palette-harmony',
    label: 'Palette & Harmony',
    description: 'Building balanced palettes - complementary, analogous and triadic schemes.',
    color: '#1ECFB6',
  },
  {
    key: 'accessibility',
    label: 'Accessibility',
    description: 'Readable color: contrast, WCAG and APCA, and color vision deficiency.',
    color: '#34C759',
  },
  {
    key: 'places',
    label: 'Inspiration',
    description: 'The cities and landscapes behind Codigrate themes.',
    color: '#BB719B',
  },
  {
    key: 'platforms',
    label: 'Platforms',
    description: 'JetBrains, VS Code, Cursor, Chrome, Slack, Ghostty and beyond.',
    color: '#FFA94D',
  },
  {
    key: 'open-source',
    label: 'Open Source',
    description: 'Our open-source theme repositories and how they are built.',
    color: '#9D7BFF',
  },
];

export const BLOG_CATEGORY_MAP: { [ key: string ]: BlogCategory } =
  BLOG_CATEGORIES.reduce( ( acc, c ) => {
    acc[ c.key ] = c;
    return acc;
  }, {} as { [ key: string ]: BlogCategory } );
